import { Page } from "../../component/page"
import { TitleWithLine } from "../../component/title-with-line"
import data from "../../data/contact.json"
import styles from "./styles.module.scss"

export const Contact = ({}) => {
  return (
    <Page>
      <TitleWithLine content={data.administrator.title} />
      <div className={styles.body}>
        <p className={styles.label}>
          { data.administrator.name }
        </p>
        <a href={`mailto:${data.administrator.email}`}>
          { data.administrator.email }
        </a>
        <p>
          { data.administrator.phone }
        </p>
        <p>
          { data.administrator.address }
        </p>
      </div>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3615.431390849238!2d121.53896767557164!3d25.01943013887768!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442aa266982a61d%3A0x73054453d07310fe!2sC.S.I.E.%20Building%20(Der%20Tian%20Hall)%2C%20Da%E2%80%99an%20District%2C%20Taipei%20City%2C%20106!5e0!3m2!1sen!2stw!4v1694414200684!5m2!1sen!2stw"
        width="400"
        height="300"
        style={{border: 0}}
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      />
    </Page>
  )
}

export default Contact